const labels = {
  "Financial Services": {
    averageOrderValue: {
      label: "Average Transaction Value ($)",
      description: "Average revenue per transaction, calculated by dividing total revenue by number of transactions."
    },
    annualCustomerValue: {
      label: "Annual Revenue per Customer ($)",
      description: "Average yearly revenue from a customer."
    },
    conversionRate: {
      label: "Present Conversion Rate (%)",
      description: "Current percentage of recipients taking the desired action, like transacting or signing up."
    }
  },
  "E-commerce": {
    averageOrderValue: {
      label: "Average Order Value ($)",
      description: "Average revenue per order, calculated by dividing total revenue by number of orders."
    },
    conversionRate: {
      label: "Present Conversion Rate (%)",
      description: "Current percentage of recipients taking the desired action, like purchasing or signing up."
    }
  },
  Subscriptions: {
    averageOrderValue: {
      label: "Average Subscription Value ($)",
      description: "Average revenue generated per subscriber, it is calculated by dividing total Subscription revenue by the number of subscribers."
    },
    annualCustomerValue: {
      label: "Annual Subscriber Value ($)",
      description: "Average yearly revenue from a subscriber."
    },
    churnRate: {
      label: "Present Churn Rate (%)",
      description: "Percentage of subscribers who cancel their subscriptions during a given time period."
    },
    conversionRate: {
      label: "Present Conversion Rate (%)",
      description: "Current percentage of recipients taking the desired action, like subscribing or signing up"
    }
  },
  Gaming: {
    averageOrderValue: {
      label: "Total Value of Cash Deposited in Wallet ($)",
      description: "Total monetary value of cash that the player has deposited in their wallet to pay for in-app purchases."
    },
    annualCustomerValue: {
      label: "Annual Player Value ($)",
      description: "Average yearly revenue from a player."
    },
    churnRate: {
      label: "Present Churn Rate (%)",
      description: "Percentage of players who stop playing the game over a given time period."
    },
    conversionRate: {
      label: "Present Conversion Rate (%)",
      description: "Current percentage of recipients taking the desired action, like purchasing or signing up"
    }
  },
  Other: {
    averageOrderValue: {
      label: "Average Revenue Per User ($)",
      description: "Average revenue generated per user, it is calculated by dividing total revenue by the number of users."
    },
    annualCustomerValue: {
      label: "Annual Customer Value ($)",
      description: "Average yearly revenue from a customer."
    },
    operatingMargin: {
      label: "Net Operating Margin (%)",
      description: "Profitability percentage showing earnings after operating expenses."
    },
    churnRate: {
      label: "Present Churn Rate (%)",
      description: "Percentage of customers who stop using a company's services or products over a given time period."
    },
    conversionRate: {
      label: "Present Conversion Rate (%)",
      description: "Current percentage of recipients taking the desired action."
    }
  }
};
export function labelsFor(industry) {
  return Object.keys(labels.Other).reduce((acc, key) => {
    if (labels[industry] && labels[industry][key]) {
      acc[key] = labels[industry][key];
    } else {
      acc[key] = labels.Other[key];
    }
    return acc;
  }, {});
}
;
